export default __webpack_public_path__ + "static/media/Zoom.bee7ff43.svg";